import { IAppState } from "..";

const selectState = (state: IAppState) => {
  return state.root;
};

export const selectSnackbar = (state: IAppState) => {
  return selectState(state).snackbar;
};

export const selectImageModal = (state: IAppState) => {
  return selectState(state).imageModal;
};
